import axios from 'axios';
import React, { useState } from 'react'
import { useToasts } from 'react-toast-notifications';

export default function Contact() {
  const { addToast } = useToasts()
  const [loading, setLoading] = useState(false)
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!navigator.onLine) {
      window.scrollTo(0, 0)
      addToast("No Internet Connection!", { appearance: "error" })
      return
    }
    setLoading(true)
    const formData = Object.fromEntries(new FormData(e.target).entries());
    const response = await axios.post("https://public.herotofu.com/v1/bb31c320-cafd-11ec-a557-034a17e2da28", formData)
    console.log(response)
    if (response.status === 200) {
      window.scrollTo(0, 0)
      setLoading(false)
      addToast("Thanks, I will get back to you in 24hrs time", { appearance: "success" })
    } else {
      window.scrollTo(0, 0)
      setLoading(false)
      addToast("Something went wrong, Please try again later!", { appearance: "error" })
    }

    e.target.reset()
  }
  return (

    <section id="contact" className="contact">
      <div className="container">

        <div className="section-title">
          <h2>Contact</h2>
          <p>Contact Me</p>
        </div>

        <div className="row mt-2">

          <div className="col-md-6 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-map"></i>
              <h3>My Address</h3>
              <p>Lagos, Nigeria</p>
            </div>
          </div>

          <div className="col-md-6 mt-4 mt-md-0 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-share-alt"></i>
              <h3>Social Profiles</h3>
              <div className="social-links">
                <a href="https://twitter.com/igbo_dev" target="_blank" rel='noreferrer' className="twitter"><i className="bi bi-twitter"></i></a>
                <a href="https://www.hackerrank.com/kmbawuike?hr_r=1" target="_blank" rel='noreferrer' className="facebook"><i
                  className="bi bi-code-slash"></i></a>
                <a href="https://github.com/kmbawuike" target="_blank" rel='noreferrer' className="instagram"><i className="bi bi-github"></i></a>
                <a href="https://www.linkedin.com/in/mbawuikekelechi/>" className="linkedin"><i
                  className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>

          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-envelope"></i>
              <h3>Email Me</h3>
              <p>kmbawuike@gmail.com</p>
            </div>
          </div>
          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-phone-call"></i>
              <h3>Call Me</h3>
              <p>+234 706 134 1943</p>
            </div>
          </div>
        </div>

        <form className="php-email-form mt-4" onSubmit={handleSubmit} >
          <div className="row">
            <div className="col-md-6 form-group">
              <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
            </div>
            <div className="col-md-6 form-group mt-3 mt-md-0">
              <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
            </div>
          </div>
          <div className="form-group mt-3">
            <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required />
          </div>
          <div className="form-group mt-3">
            <textarea className="form-control" name="message" rows="5" placeholder="Message" required></textarea>
          </div>
          <div className="text-center mt-4"><button disabled={loading} type="submit">
            {loading ? "Sending..." : "Send Message"}

          </button>
          </div>
        </form>

      </div>
    </section>
  )
}
